import { Component, ChangeDetectionStrategy, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BadgeModule } from 'primeng/badge';

@Component({
  selector: 'app-conversations-badge',
  standalone: true,
  imports: [CommonModule, BadgeModule],
  template: `
    @if (unreadCount() > 0) {
      <p-badge [value]="unreadCount().toString()" severity="danger" />
    }
  `,
  styles: [':host { display: inline-flex; }'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConversationsBadgeComponent {
  readonly unreadCount = input<number>(0);
}
